import { GetterTree } from 'vuex';
import { State } from './state';

import { RootState } from '@/modules/ewerp/store';
import { KeyValuePair, Land, Planung } from '@/modules/ewerp/models/PlanungModels';

export type Getters = {
  planung(state: State): Array<Planung>;
  produktionsauftraege(state: State): Array<Planung>;
  palettenProStunde(state: State): Array<KeyValuePair>;
  laender(state: State): Array<Land>;
};

export const getters: GetterTree<State, RootState> & Getters = {
  planung(state: State) {
    return state.planung;
  },

  produktionsauftraege(state: State) {
    return state.produktionsauftraege;
  },

  palettenProStunde(state: State) {
    return state.palettenProStunde;
  },

  laender(state: State) {
    return state.laender;
  },
};
